//get items from cart
export const getItems = async () => {
  const response = await fetch("/cart.js");
  if (response.status === 200) {
    return response.json();
  }
  throw new Error(
    `Failed to get items from cart, Shopify returned ${response.status} ${response.statusText}`
  );
};

//add items to cart
export const addItems = async (items) => {
  const options = {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ items }),
  };
  const response = await fetch("/cart/add.js", options);
  if (response.status === 200) {
    return response;
  }
  throw new Error(
    `Failed to add items to cart, Shopify returned ${response.status} ${response.statusText}`
  );
};

//remove items from cart
export const removeItems = async (keys) => {
  const updates = keys.map((k) => `"${k}": 0`).join(",");
  const options = {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: `{"updates":{${updates}}}`,
  };
  const response = await fetch("/cart/update.js", options);
  if (response.status === 200) {
    return response;
  }
  throw new Error(
    `Failed to remove items to cart, Shopify returned ${response.status} ${response.statusText}`
  );
};
